import React from 'react'

const IconX = ({ style = {}, ...props }) => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={style}
      {...props}>
      <title>x-logo</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="x-logo" fill="#000000" fillRule="nonzero">
          <path
            d="M9.52373333,6.77568693 L15.4810667,0 L14.0698667,0 L8.89493333,5.88203164 L4.7648,0 L0,0 L6.24693333,8.8955204 L0,16 L1.4112,16 L6.87253333,9.78704413 L11.2352,16 L16,16 M1.92053333,1.04126561 L4.08853333,1.04126561 L14.0688,15.0098918 L11.9002667,15.0098918"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  )
}

export default IconX
